import WalletIcon from '@/assets/wallet.svg?react'
import ClickWrapper from '@/components/ClickWrapper'
import Tooltip, { type TooltipProps } from '@/components/Tooltip'
import usePostDraft, { DraftType } from '@/utils/hooks/usePostDraft'
import useUserGuide from '@/utils/hooks/useUserGuide'
import { useEffect, useState } from 'react'
import { useFormState } from 'react-hook-form'
import { PostFormValue } from './PostForm/schemas'
import styles from './RecoverDraftButton.module.css'
import { RepostFormValue } from './RepostForm/types'

export interface RecoverDraftButtonProps extends Omit<
	TooltipProps,
	'autoHide' | 'children' | 'content' | 'onClose' | 'onCloseButtonClick' | 'opened' | 'position'
> {
	onRecover: (value: PostFormValue | RepostFormValue) => void
	draftType: DraftType
}

export default function RecoverDraftButton({
	onRecover,
	draftType,
	...props
}: RecoverDraftButtonProps) {
	const formState = useFormState()

	const [hasDraftRecoverTooltipSeen, markDrafRecoverTooltipSeen] =
		useUserGuide('DRAFT_RECOVER_TOOLTIP')
	const [draft, , removeDraft, noDraft] = usePostDraft(draftType)

	const [isShow, setIsShow] = useState<boolean>(!noDraft && !hasDraftRecoverTooltipSeen)

	useEffect(() => {
		if (!noDraft && !hasDraftRecoverTooltipSeen) {
			setIsShow(true)
		}
	}, [hasDraftRecoverTooltipSeen, noDraft])

	useEffect(() => {
		if (formState.isSubmitted) {
			removeDraft()
		}
	}, [formState.isSubmitted, removeDraft])

	if (!draft || noDraft) {
		return null
	}

	return (
		<Tooltip
			content="从草稿箱中恢复未发送的内容"
			position="bottom"
			{...props}
			opened={isShow}
			withCloseButton
			onCloseButtonClick={() => {
				setIsShow(false)
				markDrafRecoverTooltipSeen()
			}}
		>
			<ClickWrapper
				className={styles.root}
				title="恢复草稿"
				onClick={() => {
					onRecover(draft)
				}}
			>
				<WalletIcon className={styles.icon} />
			</ClickWrapper>
		</Tooltip>
	)
}
